import { createContext, useContext } from "react";

type ErrorLogger = (
  options: {
    message: string;
    additional: Record<string, string | undefined>;
  },
  error: Error,
) => void;

type Options = {
  logError: ErrorLogger;
};

const Context = createContext<Options>({
  logError: () => {},
});

export const ErrorBoundaryOptionsProvider = Context.Provider;

export const useErrorBoundaryOptions = () => useContext(Context);
